import { normalizeTextUppercase } from "../utils";

function findInputElement(el) {
  if (!el) {
    return null;
  }

  if (el.tagName === "INPUT" || el.tagName === "TEXTAREA") {
    return el;
  }

  return el.querySelector("input, textarea");
}

function isUppercaseEnabled(binding) {
  return !binding || binding.value !== false;
}

function setCursorPosition(input, start, end) {
  if (
    !input ||
    typeof input.setSelectionRange !== "function" ||
    start === null ||
    start === undefined
  ) {
    return;
  }

  input.setSelectionRange(start, end);
}

function normalizeComponentValue(el, vnode, value) {
  const normalized = normalizeTextUppercase(value);

  if (normalized === value) {
    return;
  }

  const input = findInputElement(el);
  const selectionStart = input ? input.selectionStart : null;
  const selectionEnd = input ? input.selectionEnd : null;
  const component = vnode && vnode.componentInstance;

  if (input && input.value !== normalized) {
    input.value = normalized || "";
  }

  if (component) {
    component.$emit("input", normalized);
    component.$nextTick(() => setCursorPosition(input, selectionStart, selectionEnd));
    return;
  }

  if (input) {
    input.dispatchEvent(new Event("input", { bubbles: true }));
    setCursorPosition(input, selectionStart, selectionEnd);
  }
}

function bindUppercase(el, binding, vnode) {
  if (!isUppercaseEnabled(binding)) {
    return;
  }

  const component = vnode && vnode.componentInstance;

  if (component) {
    const handler = (value) => normalizeComponentValue(el, vnode, value);
    component.$on("input", handler);
    el.__uppercaseHandler__ = handler;
    return;
  }

  const input = findInputElement(el);

  if (!input) {
    return;
  }

  const handler = () => normalizeComponentValue(el, vnode, input.value);
  input.addEventListener("input", handler);
  el.__uppercaseHandler__ = handler;
}

export default {
  inserted: bindUppercase,
  componentUpdated(el, binding, vnode) {
    if (!isUppercaseEnabled(binding)) {
      return;
    }

    const component = vnode && vnode.componentInstance;
    const value = component ? component.value : binding.value;

    normalizeComponentValue(el, vnode, value);
  },
  unbind(el, binding, vnode) {
    const component = vnode && vnode.componentInstance;
    const input = findInputElement(el);
    const handler = el.__uppercaseHandler__;

    if (component && handler) {
      component.$off("input", handler);
    } else if (input && handler) {
      input.removeEventListener("input", handler);
    }

    delete el.__uppercaseHandler__;
  },
};
